import { render } from "./PlateComponent.vue?vue&type=template&id=6dca09cf&ts=true"
import script from "./PlateComponent.vue?vue&type=script&lang=ts"
export * from "./PlateComponent.vue?vue&type=script&lang=ts"

import "./PlateComponent.vue?vue&type=style&index=0&id=6dca09cf&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__